export interface GoodwillRequest  {
    trading_account: string;
};

export interface GoodwillResponse {
    trading_account: string;
    error_message?: string;
    old_balance?: number;
    new_balance?: number;
}
